import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { InventoryService } from "@rubbl-inventory";

@Component({
  selector: "app-machine-category-media-card",
  templateUrl: "./machine-category-media-card.component.html",
  styleUrls: ["./machine-category-media-card.component.scss"],
})
export class MachineCategoryMediaCardComponent implements OnInit {
  @Input() category: { label: string; subLabel: string; value: string };
  @Input() makes: any[];
  @Input() routerUrl: string[];
  @Output() clearOutMakes = new EventEmitter<void>();

  activeLink: string;
  categoryImageUrl: string;
  visibleLimit: number = 5;

  isExpanded = false;
  imageError: boolean;

  constructor(private inventoryService: InventoryService, private router: Router) {}

  ngOnInit(): void {
    this.activeLink = this.routerUrl.slice(0, 2).join("/");
    this.categoryImageUrl = this.inventoryService.getCategoryPictureUrl(this.category.value);
  }

  get isActive(): boolean {
    return decodeURIComponent(this.router.url.toLowerCase()).startsWith(this.activeLink.toLowerCase());
  }

  wipeOutMakes(): void {
    this.makes = [];
    this.clearOutMakes.emit();
  }

  getMakeRouterUrl(make: any): string[] {
    return [...this.routerUrl, make];
  }

  onToggle(event: Event): void {
    this.isExpanded = (event.target as HTMLDetailsElement).open;
  }

  onImageError(event: any) {
    event.target.src = "https://company.rubbl.com/pubweb/marketplace/images/images/no-machine-image-placeholder.png";

    this.imageError = true;
  }
}
